export const getSignedIn = (state) => state?.auth?.isSignedIn;

export const getUserData = (state) => state?.auth?.user ?? {};

export const getUserPermissions = (state) => state?.auth?.userPermissionList ?? [];

export const getUserPermissionData = (state) => state?.auth?.userPermissionData ?? {};

export const getCanRedirectToWorkspace = (state) => state?.auth?.canRedirectToWorkspace;

export const getUiCountMax = (state) => state?.auth?.uiCountMax;

export const getUiCount = (state) => state?.auth?.uiCount;

export const getBackendVersion = (state) => state?.auth?.backendVersion ?? null;

export const getAuthCheckPublicInfo = (state) => state?.auth?.authCheckPublicInfo ?? {};
